<script>
export default {
  //   props: {
  //     hideClose: Boolean
  //   },
  mounted() {
    window.oncontextmenu = function() {
      console.log(">>>>>??????");
      return false;
    };
    // window.onbeforeunload = function(e) {
    //   var dialogText = "训练尚未完成！请勿刷新或退出！";
    //   e.returnValue = dialogText;
    //   console.log("e", e);
    //   return dialogText;
    // };
    document.addEventListener("keydown", this.KeyDown);
    window.onbeforeunload = "当前操作未保存，如果你此时离开，所做操作信息将全部丢失，是否离开?";
    var goodexit = false;
    function bindunbeforunload() {
      goodexit = false;

    }
    function unbindunbeforunload() {
      goodexit = true;
      window.onbeforeunload = null;
    }
    function perforresult() {
      if (!goodexit) {
        return "当前操作未保存，如果你此时离开，所做操作信息将全部丢失，是否离开?";
      }
    }
  },
  methods: {
    KeyDown() {
      console.log(">>>>>>", window.event.altKey, window.event.keyCode, event.ctrlKey);
      if (
        window.event.altKey &&
        (window.event.keyCode == 37 || //屏蔽 Alt+ 方向键 ←
          window.event.keyCode == 39)
      ) {
        //屏蔽 Alt+ 方向键 →
        console.log("不准你使用ALT+方向键前进或后退网页！");
        event.returnValue = false;
      }
      if (event.keyCode == 116) {
        //屏蔽 F5 刷新键
        console.log("禁止F5刷新网页！");
        event.keyCode = 0;
        event.returnValue = false;
      }
      if (event.ctrlKey && event.keyCode == 82) {
        //屏蔽 Ctrl+R
        console.log("禁止Ctrl+R刷新网页！");
        event.returnValue = false;
      }
      if (event.shiftKey && event.keyCode == 121) {
        //屏蔽 shift+F10
        console.log("禁止shift+F10刷新网页！");
        event.returnValue = false;
      }
    }
  }
};
</script>

<template>
  <div @keydown="KeyDown" oncontextmenu="event.returnValue=false">
    <slot></slot>
  </div>
</template>




// WEBPACK FOOTER //
// yotta-vue-components/vision/ForbidRefreshView.vue